import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, Injector, NgModule } from '@angular/core';
import { AppConfigService } from './services/app-config/app-config.service';
import { BrowserModule } from '@angular/platform-browser';

import { CommonModule, DatePipe, LOCATION_INITIALIZED } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { MatDialogModule } from '@angular/material/dialog';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router, TitleStrategy } from '@angular/router';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import * as Sentry from '@sentry/angular-ivy';
import { NgxMatIntlTelInputComponent } from 'ngx-mat-intl-tel-input';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CustomPaginator } from './components/custom-paginator/custom-paginator-configuration.component';
import { TemplateTitleStrategy } from './pages/title-pages/template.title-strategy';
import { DateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ComponentsModule } from './components/components.module';
import { SharedModule } from 'src/shared/shared.module';
//import { StockQuantityFormatPipe } from '../pipes/stock-quantity-format.pipe';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

export function AppConfigInitializerFactory(appConfig: AppConfigService) {
  return () => appConfig.initialize();
}

export function ApplicationInitializerFactory(
  translate: TranslateService, injector: Injector) {
  return async () => {
    await injector.get(LOCATION_INITIALIZED, Promise.resolve(null));

    const deaultLang = 'pt';
    translate.addLangs(['en', 'pt']);
    translate.setDefaultLang(deaultLang);
    try {
      let language = await translate.getBrowserLang();
      await translate.use(language == "pt" ? language : "en").toPromise();
    } catch (err) {
      console.error(err);
    }
  };
}
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    SharedModule,
    ComponentsModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NgxMatIntlTelInputComponent,
    HttpClientModule,
    MatDialogModule,
    CommonModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: AppConfigInitializerFactory,
      deps: [AppConfigService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: ApplicationInitializerFactory,
      deps: [TranslateService, Injector, Sentry.TraceService],
      multi: true
    },
    MatSnackBar,
    { provide: MatPaginatorIntl, useClass: CustomPaginator },
    { provide: TitleStrategy, useClass: TemplateTitleStrategy },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    DatePipe
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
